import React from 'react';
import AccountContext from '../../../context/account/account.context';
import { StoryblokCommon } from '../../../lib/storyblok/storyblok';

import * as HsButtonStylesHs from './hs-button.hs.module.scss';
import * as HsButtonStylesDr from './hs-button.dr.module.scss';

const HsButton = ({
    children,
    appearance = 'primary',
    type = 'button',
    onClick = null,
    disabled = false,
    icon,
    size = 'standard',
    className,
    openLogin = false,
    storyblokCommon,
    ariaLabel,
    id,
}: {
    children?: any;
    appearance?: 'primary' | 'secondary';
    type?: 'button' | 'reset' | 'submit';
    onClick?: any;
    disabled?: boolean;
    icon?: 'plus' | 'close' | 'delete' | 'back';
    size?: 'small' | 'standard' | 'large';
    className?: string;
    openLogin?: boolean;
    storyblokCommon: StoryblokCommon;
    ariaLabel?: string;
    id?: string;
}) => {
    const [buttonClasses, changeButtonClasses] = React.useState<any[]>([]);
    const HsButtonStyles = storyblokCommon.configuration.content.theme === 'dr' ? HsButtonStylesDr : HsButtonStylesHs;
    const accountContext = React.useContext(AccountContext);

    if (openLogin) {
        onClick = () => accountContext.signIn(storyblokCommon.configuration.content.language, storyblokCommon.configuration.content.theme);
    }

    React.useEffect(() => {
        if (HsButtonStyles) {
            const classes: string[] = [];

            if (size === 'small') {
                classes.push(HsButtonStyles.sizeSmall);
            } else if (size === 'large') {
                classes.push(HsButtonStyles.sizeLarge);
            } else {
                classes.push(HsButtonStyles.sizeStandard);
            }

            if (className) {
                classes.push(className);
            }

            if (icon) {
                classes.push(HsButtonStyles.icon);

                switch (icon) {
                    case 'plus':
                        classes.push(HsButtonStyles.iconPlus);
                        break;
                    case 'close':
                        classes.push(HsButtonStyles.iconClose);
                        break;
                    case 'delete':
                        classes.push(HsButtonStyles.iconDelete);
                        break;
                    case 'back':
                        classes.push(HsButtonStyles.iconBack);
                }
            }

            changeButtonClasses(classes);
        }
    }, [HsButtonStyles]);

    return (
        <>
            {HsButtonStyles && (
                <button
                    id={id || 'button-' + children}
                    aria-label={ariaLabel}
                    type={type}
                    className={[HsButtonStyles.hsButton, HsButtonStyles[appearance], ...buttonClasses].join(' ')}
                    onClick={onClick}
                    disabled={disabled}
                >
                    {children}
                </button>
            )}
        </>
    );
};

export default HsButton;
